import type { ErrorInfo, ReactNode } from 'react'
import React, { Component } from 'react'

interface Props {
	children: ReactNode
}

interface State {
	hasError: boolean
	error?: Error
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false
	}

	public static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error }
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('Uncaught error:', error, errorInfo)
	}

	public render() {
		if (this.state.hasError) {
			return (
				<div style={{
					padding: '20px',
					textAlign: 'center',
					color: 'white',
					backgroundColor: '#1a1a1a'
				}}>
					<h2>Something went wrong</h2>
					<details style={{ whiteSpace: 'pre-wrap', textAlign: 'left', marginTop: '20px' }}>
						<summary>Error details</summary>
						{this.state.error && this.state.error.toString()}
					</details>
					<button
						onClick={() => window.location.reload()}
						style={{
							marginTop: '20px',
							padding: '10px 20px',
							backgroundColor: '#0078d4',
							color: 'white',
							border: 'none',
							borderRadius: '4px',
							cursor: 'pointer'
						}}
					>
						Reload Page
					</button>
				</div>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary
